<template>
    <div class="col-12 row">
        <div class="col-12 mb-3">
            <button class="btn btn-success" @click="addVariant">
                Add
            </button>
        </div>
        <div
            v-for="(variant, index) of variants"
            :key="index"
            class="col-12 d-flex flex-wrap my-2"
        >
            <div class="col-3">
                <label>Product</label>
                <product-selector
                    :shop-id="shopId"
                    :disabled="variant.isSaved"
                    @input="productChanged($event, index)"
                />
                <small
                    v-if="
                        variant.product && variant.product.onlyForAgudaMembers
                    "
                >
                    This product is only for Aguda Members.
                </small>
            </div>
            <div class="col-5">
                <label>Variant</label>
                <v-select
                    v-if="variant.productId"
                    v-model="variant.id"
                    placeholder="Search..."
                    :disabled="variant.isSaved"
                    :get-option-label="getVariantLabel"
                    :reduce="item => item.id"
                    :options="variant.variants"
                />
            </div>
            <div class="form-group col-2">
                <label>Quantity</label>
                <input
                    v-model="variant.quantity"
                    :disabled="variant.isSaved"
                    type="number"
                    class="form-control"
                />
            </div>
            <div
                class="col-2 d-flex flex-wrap justify-content-end align-items-center"
            >
                <button
                    v-if="!variant.isSaved"
                    :disabled="!variant.id"
                    class="btn btn-success mx-2"
                    @click="saveVariant(index)"
                >
                    Save
                </button>
                <button class="btn btn-danger" @click="removeVariant(index)">
                    Delete
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import ProductSelector from '@/components/products/Selector';

export default {
    components: {
        ProductSelector
    },

    props: {
        shopId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            variants: []
        };
    },

    watch: {
        shopId() {
            this.variants = [];
            this.emitVariants();
        }
    },

    methods: {
        ...mapActions({
            getVariants: 'products/getVariants'
        }),

        addVariant() {
            if (
                this.variants.length &&
                !this.variants[this.variants.length - 1].isSaved
            ) {
                return this.$toaster(
                    'Please save previous product before add new one.',
                    { variant: 'warning', title: 'Warn!' }
                );
            }

            this.variants.push({
                quantity: 1
            });
        },

        removeVariant(index) {
            this.variants.splice(index, 1);

            this.emitVariants();
        },

        saveVariant(index) {
            const product = this.variants[index];

            const { price, agudaPrice } = product.variants.find(
                variant => variant.id === product.id
            );

            this.variants.splice(index, 1, {
                ...product,
                isSaved: true,
                price,
                agudaPrice
            });

            this.emitVariants();
        },

        async productChanged(product, index) {
            try {
                const { rows: variants } = await this.getVariants({
                    id: product.id,
                    perPage: 100
                });

                this.variants.splice(index, 1, {
                    ...this.variants[index],
                    productId: product.id,
                    product: {
                        ...product
                    },
                    variants: variants.map(
                        ({ id, price, agudaPrice, attributes }) => ({
                            id,
                            price,
                            agudaPrice,
                            attributes
                        })
                    )
                });
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        },

        getVariantLabel(variant) {
            const attributes = variant.attributes.map(({ group, value }) => {
                const { name, unit } = group;

                return `${name}: ${value}${unit || ''}`;
            });

            return attributes.join(', ');
        },

        emitVariants() {
            this.$emit('input', cloneDeep(this.variants));
        }
    }
};
</script>
